import { DIR_LTR, NAV_TYPE_SIDE, SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Raid Hut Admin";
export const API_BASE_URL = env.API_ENDPOINT_LAMBDA;
export const API_STORE_URL = env.API_ENDPOINT_STORE;
export const API_TWITCH_URL = env.API_ENDPOINT_TWITCH;
export const API_RAIDMACHINE_URL = env.API_ENDPOINT_RAIDMACHINE;
export const API_ACCOUNT_MANAGER_URL = env.API_ENDPOINT_ACCOUNT_MANAGER;
export const API_GAME_STATS_URL = env.API_ENDPOINT_GAME_STATS;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const GAME_SELECTION_PREFIX_PATH = "/game-selection";
export const KEY = process.env.REACT_APP_CONFIG_KEY;

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "br",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "dark",
  direction: DIR_LTR,
};
